export let resumeUploadUrl = '/api/file/resume/upload'
export let cloneResumeUploadUrl = '/api/file/cloneResume/upload'
export let resumeZipDownloadUrl = '/api/file/resumeZip/'
export let resumeDownloadUrl = '/api/file/resume/'
export let cloneResumeDownloadUrl = '/api/file/cloneResume/'
export let materialUploadUrl = '/api/file/engineerMaterial/upload'
export let materialDownloadUrl = '/api/file/engineerMaterial/'

export let orderTypes = {
  list: [{
    code: 1,
    name: '客户下单'
  },
  {
    code: 2,
    name: '后台下单'
  }],
  getOrderTypeName (type) {
    if (type === 1) {
      return '客户下单'
    } else {
      return '后台下单'
    }
  }
}

export let userType = {
  saleUser: 1, // 业务员
  serviceUser: 2, // 客服
  otherUser: 3, // 其它
  saleAideUser: 4 // 业务员助手
}

export let orderTag = {
  list: [
    {
      'code': 'ORDER_TAG_NONE',
      'value': 0,
      'name': ''
    },
    {
      'code': 'ORDER_TAG_DUE',
      'value': 1,
      'name': '即将到期'
    },
    {
      'code': 'ORDER_TAG_EXPIRE',
      'value': 2,
      'name': '已到期'
    },
    {
      'code': 'ORDER_TAG_NEED_PROCESS',
      'value': 3,
      'name': '需要处理'
    }
  ],
  getStatusName (value) {
    var name = ''
    orderTag.list.forEach(ele => {
      if (ele.value === value) {
        name = ele.name
      }
    })
    return name
  }
}

export let orderRequireStatus = {
  list: [
    {
      'code': 'ORDER_REQUIRE_STATUS_NEEDING',
      'value': 10,
      'name': '需求中'
    },
    {
      'code': 'ORDER_REQUIRE_STATUS_FULL',
      'value': 20,
      'name': '满员'
    }
  ],
  getStatusName (value) {
    var name = ''
    orderRequireStatus.list.forEach(ele => {
      if (ele.value === value) {
        name = ele.name
      }
    })
    return name
  }
}

export let orderStatus = {
  list: [
    {
      'code': 'ORDER_STATUS_INIT',
      'value': 21,
      'name': '待下发'
    },
    // {
    //   'code': 'ORDER_STATUS_WAIT_DISPATCH',
    //   'value': 31,
    //   'name': '待派单'
    // },
    {
      'code': 'ORDER_STATUS_DISPATCHING',
      'value': 31,
      'name': '派单中'
    },
    // {
    //   'code': 'ORDER_STATUS_DISPATCHED',
    //   'value': 51,
    //   'name': '已派单'
    // },
    {
      'code': 'ORDER_STATUS_EXECUTE',
      'value': 51,
      'name': '执行中'
    },
    {
      'code': 'ORDER_STATUS_FINISH',
      'value': 61,
      'name': '已完成'
    },
    {
      'code': 'ORDER_STATUS_CANCEL',
      'value': 11,
      'name': '已关闭'
    }
    // {
    //   'code': 'ORDER_STATUS_REJECT',
    //   'value': 12,
    //   'name': '已拒绝'
    // }
  ],
  getStatusName (value) {
    var name = ''
    orderStatus.list.forEach(ele => {
      if (ele.value === value) {
        name = ele.name
      }
    })
    return name
  }
}

export let orderEngineerStatus = {
  list: [
    {
      code: 'STATUS_ENGINEER_DELIVER_INIT',
      value: 0,
      name: '未接收',
      nextValue: 11
    },
    {
      code: 'STATUS_ENGINEER_DELIVER_RECEIVED',
      value: 11,
      name: '客服接收',
      nextValue: 12
    },
    // {
    //   code: 'STATUS_ENGINEER_DELIVER_SUBMIT',
    //   value: 12,
    //   name: '客服提交'
    // },
    {
      code: 'STATUS_ENGINEER_DELIVER_NOPASS',
      value: 102,
      name: '不通过'
    },
    {
      code: 'STATUS_ENGINEER_DELIVER_EXPIRED',
      value: 104,
      name: '已过期'
    },
    {
      code: 'STATUS_ENGINEER_ORDER_QUIZ_APPOINTMENT',
      value: 31,
      name: '待预约面试',
      nextValue: 32
    },
    {
      code: 'STATUS_ENGINEER_ORDER_QUIZ_APPOINTMENTED',
      value: 32,
      name: '已预约面试',
      nextValue: 33
    },
    {
      code: 'STATUS_ENGINEER_ORDER_QUIZ_RESULT',
      value: 33,
      name: '待面试结果',
      nextValue: 41
    },
    {
      code: 'STATUS_ENGINEER_ORDER_TOBE_EMPLOYED',
      value: 41,
      name: '待上岗',
      nextValue: 51
    },
    {
      code: 'STATUS_ENGINEER_ORDER_EXECUTING',
      value: 51,
      name: '已入职',
      preValue: 41,
      nextValue: 61
    },
    {
      code: 'STATUS_ENGINEER_ORDER_FINISH',
      value: 61,
      name: '已完成',
      preValue: 51,
      endNode: true
    },
    {
      code: 'STATUS_ENGINEER_ORDER_NO_PASS',
      value: 101,
      name: '面试不通过'
    },
    // {
    //   code: 'STATUS_ENGINEER_ORDER_NO_RESPONSE',
    //   value: 103,
    //   name: '未回应'
    // },
    {
      code: 'STATUS_ENGINEER_ORDER_DRAIN',
      value: 105,
      name: '流单'
    },
    {
      code: 'STATUS_ENGINEER_ORDER_BREAK',
      value: 106,
      name: '流程中断'
    },
    {
      code: 'STATUS_ENGINEER_ORDER_BREAK',
      value: 107,
      name: '已交接'
    }
  ],
  getStatusNode (value) {
    var node = {}
    orderEngineerStatus.list.forEach(ele => {
      if (ele.value === value) {
        node = ele
      }
    })
    return node
  },
  getStatusName (value) {
    var name = ''
    var node = orderEngineerStatus.getStatusNode(value)
    if (node) {
      name = node.name
    }
    return name
  },
  getPreStatus (value) {
    var preValue = null
    orderEngineerStatus.list.forEach((ele, i) => {
      if (ele.value === value) {
        preValue = ele.preValue
      }
    })
    return preValue
    // return orderEngineerStatus.list[currStatusIndex + 1].value
  },
  getNextStatus (value) {
    var nextValue = null
    orderEngineerStatus.list.forEach((ele, i) => {
      if (ele.value === value) {
        nextValue = ele.nextValue
      }
    })
    return nextValue
    // return orderEngineerStatus.list[currStatusIndex + 1].value
  },
  getStatusValue (code) {
    var value = ''
    orderEngineerStatus.list.forEach(ele => {
      if (ele.code === code) {
        value = ele.value
      }
    })
    return value
  }
}

// export let workYears = {
//   list: [
//   {
//     code: '1',
//     name: '1年以下'
//   },
//   {
//     code: '2',
//     name: '1到3年'
//   },
//   {
//     code: '3',
//     name: '3到5年'
//   },
//   {
//     code: '4',
//     name: '5到8年'
//   },
//   {
//     code: '5',
//     name: '10年以上'
//   }],
//   getName (code) {
//     return getBName(workYears.list, code, '')
//   }
// }

export let schoolingRecords = {
  list: [
  {
    code: '1',
    name: '高中及以上'
  },
  {
    code: '2',
    name: '大专以及上'
  },
  {
    code: '3',
    name: '本科及以上'
  },
  {
    code: '4',
    name: '研究生及以上'
  }],
  getName (code) {
    return getBName(schoolingRecords.list, code, '')
  }
}

export let ages = {
  list: [
  {
    code: '1',
    name: '25以下'
  },
  {
    code: '2',
    name: '30以下'
  },
  {
    code: '3',
    name: '35以下'
  },
  {
    code: '4',
    name: '45以下'
  },
  {
    code: '5',
    name: '50以下'
  }],
  getName (code) {
    var name = ''
    ages.list.forEach(ele => {
      if (ele.code === code) {
        name = ele.name
      }
    })
    return name
  }
}

export let expectSalarys = {
  list: [
  {
    code: '1',
    name: '5-10K'
  },
  {
    code: '2',
    name: '11-15K'
  },
  {
    code: '3',
    name: '15-20K'
  },
  {
    code: '4',
    name: '20-25K'
  },
  {
    code: '5',
    name: '25-30K'
  },
  {
    code: '6',
    name: '30K以上'
  }],
  getName (code, nullShowText) {
    return getBName(expectSalarys.list, code, nullShowText)
  }
}

export let sexs = {
  getName (sex) {
    if (sex === 1 || sex === '1') {
      return '男'
    }
    return '女'
  }
}

export let engineerStatus = {
  list: [
    {
      code: 0,
      name: '未审核'
    },
    {
      code: 1,
      name: '已审核'
    },
    {
      code: 2,
      name: '执行中'
    }
  ],
  getName (value) {
    return getBName(engineerStatus.list, value)
  }
}

export let industryTypes = {
  list: [
  {
    code: '1',
    name: '石油化工'
  },
  {
    code: '2',
    name: '医药'
  },
  {
    code: '3',
    name: '海工'
  },
  {
    code: '4',
    name: '环保'
  },
  {
    code: '5',
    name: '电子等行业工程设计'
  },
  {
    code: '6',
    name: '施工及管理技术服务'
  }],
  getName (code, nullShowText) {
    return getBName(industryTypes.list, code, nullShowText)
  }
}

export let insizes = {
  list: [
  {
    code: '1',
    name: '0~50'
  },
  {
    code: '2',
    name: '50~500'
  },
  {
    code: '3',
    name: '500以上'
  }],
  getName (code, nullShowText) {
    return getBName(insizes.list, code, nullShowText)
  }
}

export let businessTypes = {
  list: [
  {
    code: '1',
    name: '国企'
  },
  {
    code: '2',
    name: '外企'
  },
  {
    code: '3',
    name: '私企'
  },
  {
    code: '4',
    name: '民企'
  },
  {
    code: '5',
    name: '合资企业'
  }],
  getName (code, nullShowText) {
    return getBName(businessTypes.list, code, nullShowText)
  }
}

function getBName (list, code, nullShowText) {
  if (code === null || code === '' || typeof (code) === 'undefined') {
    if (typeof (nullShowText) === 'undefined') {
      return ''
    }
    return nullShowText
  }
  var name = ''
  list.forEach(ele => {
    if (ele.code === code) {
      name = ele.name
    }
  })
  return name
}



// WEBPACK FOOTER //
// ./src/util/enum.js